module.exports = __webpack_public_path__ + "media/warranty-claim/plus-icon-4f7a471c.svg";